import * as React from "react";
import i18n from "i18n";
import ViewsHighlightingRules from "views/components/sidebar/highlighting/ViewsHighlightingRules";
import ViewDescription from "./description/ViewDescription";
import AddWidgetButton from "./create/AddWidgetButton";
const sidebarSections = [
  {
    key: "viewDescription",
    get title() {
      return i18n.t("sidebar.description", { ns: "search" });
    },
    icon: "info",
    content: ({ results }) => /* @__PURE__ */ React.createElement(ViewDescription, { results })
  },
  {
    key: "create",
    icon: "add",
    get title() {
      return i18n.t("sidebar.create", { ns: "search" });
    },
    content: ({ toggleSidebar, sidebarIsPinned }) => /* @__PURE__ */ React.createElement(AddWidgetButton, { onClick: !sidebarIsPinned ? toggleSidebar : () => {
    } })
  },
  {
    key: "highlighting",
    icon: "format_paragraph",
    get title() {
      return i18n.t("sidebar.highlighting", { ns: "search" });
    },
    content: () => /* @__PURE__ */ React.createElement(ViewsHighlightingRules, null)
  },
  {
    key: "fieldList",
    icon: "subscript",
    get title() {
      return i18n.t("sidebar.fields", { ns: "search" });
    },
    content: ({ sidebarChildren }) => sidebarChildren
  }
];
export default sidebarSections;
